import React from 'react'
import styled from 'styled-components'
import { TsReportFirst } from '../Components/Activity/TsReportFirst'
import { SelectedStaffProvider } from '../context/selectedStaff'
import { colors } from '../Shared/colors'

export const TsActivityComponent = () => {
  return (
    <Main>
      <SelectedStaffProvider>
        <TsReportFirst />
      </SelectedStaffProvider>
    </Main>
  )
}


const Main = styled.div`
background-color: ${colors.inputWhite};
min-height: calc(100vh - 10vh);
margin-top: 10vh;
display: flex;
padding-top: 2em;
flex-direction: column;
justify-content: center;
align-items: center;
`
